import { defineComponent as _defineComponent } from 'vue'
import { type AccountType } from '~/types/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'assignment',
  props: {
    account: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})